export const EMPTY_OBJECT = {};
export const EMPTY_ARRAY = [];
export const FAKE_FUNCTION = () => {};

export const SORTING_TYPES = {
  ascending: 'asc',
  descending: 'desc'
} as const;
